<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Buy from "@/components/widgets/store-buy";

export default {
  locales: {
    pt: {
    },
    es: {
      Buy: "Comprar",
    },
  },
  components: {
    Layout,
    Buy,
  },
  data() {
    return {
      product: {
        modal: false,

        id: null,
        variations: null,
        images: [],
        name: null,
        description: null,
      },

      products: {
        loading: true,
        errored: false,
        empty: false,
        list: null,
      },
    };
  },
  methods: {
    getProducts() {
      this.products.loading = true;
      this.products.errored = null;
      this.products.empty = false;
      this.products.list = null;

      api
        .get("inventory/products")
        .then((response) => {
          if (response.data.status == "success") {
            this.products.list = response.data.products;
            this.products.loading = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.products.list = [];
          }
        })
        .finally(() => {
          this.products.loading = false;
        });
    },
    showProduct(product) {
      this.product.modal = true;
      this.product.id = product.id;
      this.product.variations = product.variations;
      this.product.images = product.images;
      this.product.name = product.name;
      this.product.description = product.description;
    },
  },
  mounted() {
    this.getProducts();
  },
};
</script>

<template>
  <Layout ref="store">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/inventory/products">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/inventory/products">Reposição</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Produtos</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!products.list" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="products.list.length == 0" class="card">
      <div class="card-body">
        <div class="text-center py-5">
          <i class="far fa-sad-cry font-size-24"></i><br />
          ainda não temos nenhum produto disponível
        </div>
      </div>
    </div>

    <div v-else class="row">
      <div class="col-md-4" v-for="(product, id) in products.list" :key="id">
        <div v-if="product.instock == 'yes'">
          <div class="card card-h-fix">
            <div class="card-body">
              <div class="d-flex align-items-center flex-gap-15">
                <div style="max-width: 100px; max-height: 100px" v-for="(image, i) in product.images" :key="i">
                  <img :src="image" class="img-fluid rounded" />
                </div>
                <div class="flex-fill font-weight-bold text-dark">
                  <h6 class="mb-0">{{ product.name }}</h6>
                  <h4>{{ product.price.affiliate | currency }}</h4>
                  <Buy :id="product.id" :variations="product.variations"></Buy>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="card card-h-fix">
            <div class="card-body text-center">
              <div class="d-flex align-items-center flex-gap-15">
                <div style="max-width: 100px; max-height: 100px" v-for="(image, i) in product.images" :key="i">
                  <img :src="image" class="img-fluid rounded" />
                </div>
                <div class="flex-fill font-weight-bold text-dark">
                  <h6 class="mb-0">{{ product.name }}</h6>
                  <h4>{{ product.price.affiliate | currency }}</h4>
                  <b-button disabled block class="mt-3">INDISPONÍVEL</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="product.modal" hide-footer centered>
      <div class="mb-3">
        <b-carousel style="margin: 0 auto; max-width: 350px" controls indicators fade :interval="0">
          <b-carousel-slide style="max-width: 350px; min-height: 200px" v-for="(image, i) in product.images" :key="i" :img-src="image"></b-carousel-slide>
        </b-carousel>
      </div>
      <h4 class="font-weight-bold mb-3">{{ product.name }}</h4>
      <div v-html="product.description"></div>
    </b-modal>
  </Layout>
</template>